import React from "react";
export const LandingPageBanner = () => {
     return (
          <>
               <section className="sector-sign-up-banner">
				<div className="mtp-container-fluid">
					<div className="section-header-xl ">
						<p className="section-header-xl-secondary-text text-color-white fw-500">
							Claim Your Free Employer Profile
						</p>
						<h2 className="section-header-xl-primary-heading text-color-white fw-700 ">
							Take the first step in telling your story.
						</h2>
					</div>
				</div>
			</section>
          </>
     )
}